
<template>
  <div class="spinner-container">
    Loading... <span class="spinner">{{ spinnerThingy }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      spinnerThingy: '|',
      spinnerFrames: ['|', '/', '-', '\\'],
      currentFrame: 0,
    };
  },
  mounted() {
    this.startSpinner();
  },
  beforeDestroy() {
    clearInterval(this.spinnerInterval);
  },
  methods: {
    startSpinner() {
      this.spinnerInterval = setInterval(() => {
        this.currentFrame = (this.currentFrame + 1) % this.spinnerFrames.length;
        this.spinnerThingy = this.spinnerFrames[this.currentFrame];
      }, 250); // Rotate the spinner every 250 milliseconds
    },
  },
};
</script>

<style>
.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Arial', sans-serif;
  font-size: 20px;
}

.spinner {
  margin-left: 10px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
